// extracted by mini-css-extract-plugin
export default {"container_final_message":"FinalMessage_container_final_message__3WKfx","buttons_top":"FinalMessage_buttons_top__23kld","newTop":"FinalMessage_newTop__3h8qT"};